import * as StorageService from "../services/StorageService";
import {LOCALSTORAGE_ITEMS, PRODUCT_TYPE} from "../util/Constants";
import * as ProductService from "../services/ProductService";
import {
    changeGroupedOrders,
    confirmGroupProductsOrder,
    createGroupedOrders,
    deleteGroupedOrders,
    getAllGroupedOrders,
    getGroupedOrdersById,
    removeGroupProductsOrder,
    sendGroupedOrders,
    upsertGroupProductsOrder
} from "../services/ProductService";
import {EventBus} from "../util/EventBus";

export const getAllAvailableProductsHandler = async (shopName, productType) => {

    let allTagsAndProductsStorage = StorageService.getItem(LOCALSTORAGE_ITEMS.ALL_TAGS_AND_PRODUCTS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.ALL_TAGS_AND_PRODUCTS)) : null;
    const getAllAvailableProductsRequest = {
        "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
        "shop": shopName,
    }
    const ts = StorageService.getItem(LOCALSTORAGE_ITEMS.CALL_TS);
    if (ts && new Date().getTime() - ts > 30 * 60 * 1000) {// 30 minute 30*60*1000
        console.log("30 mins passed...removing ALL_TAGS_AND_PRODUCTS from storage");
        StorageService.removeItem(LOCALSTORAGE_ITEMS.ALL_TAGS_AND_PRODUCTS);
    }

    if (allTagsAndProductsStorage) {
        return allTagsAndProductsStorage;
    } else {
        const allAvailableProductsResponse = await ProductService.getAllAvailableProducts(getAllAvailableProductsRequest);
        const getAllAvailableExtraProductsRequest = {
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "shop": shopName,
        }
        const allExtrasResponse = await ProductService.getAllAvailableExtraProducts(getAllAvailableExtraProductsRequest);

        if (allAvailableProductsResponse.ok && allExtrasResponse.ok) {
            const allExtras = allExtrasResponse.data;
            const allProductTags = [""].concat(JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS))?.merchantConfig?.productTags);
            let tagObj = [];
            let products;

            if (productType === PRODUCT_TYPE.DINE_IN) {
                products = allAvailableProductsResponse.data.filter(product =>
                    (product.available || typeof product.available === "undefined") && (product.hasStock && product.stock > 0 || !product.hasStock) && product.dineIn);
            } else if (productType === PRODUCT_TYPE.TAKEAWAY) {
                products = allAvailableProductsResponse.data.filter(product =>
                    (product.available || typeof product.available === "undefined") && (product.hasStock && product.stock > 0 || !product.hasStock) && product.takeaway);
            }


            allProductTags.forEach(tag => {
                const allProductsForTag = products.filter(product =>
                    (product.tags?.length === 0 && tag === "") || product.tags?.includes(tag)
                );

                if (allProductsForTag.length > 0) {

                    //treaba cu extras_all
                    allProductsForTag.forEach(product => {
                        let allExtrasArray = [];

                        product.extras?.forEach(extraId => {
                            const matchingExtras = allExtras.filter(extra => extra.pid === extraId);
                            allExtrasArray = allExtrasArray.concat(matchingExtras);
                        });

                        product.extras_all = allExtrasArray;
                    });


                    //treaba cu reqExtra
                    allProductsForTag.forEach(product => {
                        const basePrice = product.price
                        let extrasPrice = 0;
                        product.reqExtras?.forEach(reqExtraId => {
                            const matchingExtra = allExtras.find(extra => extra.pid === reqExtraId);
                            if (matchingExtra) {
                                extrasPrice += matchingExtra.price;
                            }
                        });

                        const finalPriceWithReqExtras = basePrice + extrasPrice;
                        product.finalPriceWithReqExtras = finalPriceWithReqExtras;
                        product.reqExtrasPrice = extrasPrice;


                    });

                    tagObj.push({
                        "name": tag,
                        "products": allProductsForTag
                    });
                }
            });

            StorageService.setItem(LOCALSTORAGE_ITEMS.ALL_TAGS_AND_PRODUCTS, JSON.stringify(tagObj));
            return tagObj;
        } else {
            EventBus.dispatch("genericErrorMsg");
            console.log("Error retrieving available products");
            return [];
        }
    }
}


export const getGroupedOrdersByIdHandler = async (data) => {

    const body = {
        "shop": data.shop,
        "user": data.user,
        "goid": data.goid,

    }


    let error = null;
    const request = await getGroupedOrdersById(body);
    let groupedOrderResponse = null;

    if (request.ok && request?.data !== null) {
        groupedOrderResponse = request.data;

        const sortedGroupedOrder = groupedOrderResponse.orders
            .sort((a, b) => (a.user === data.user ? -1 : b.user === data.user ? 1 : 0));

        groupedOrderResponse.orders = sortedGroupedOrder;
    } else {
        error = "Error getGroupedOrdersByIdHandler";
    }
    return {
        data: {
            error: error,
            groupedOrder: groupedOrderResponse
        }
    };
}

export const getAllGroupedOrdersHandler = async (data) => {
    const body = {
        "shop": data.shop,
        "user": data.user,
        "goid": data.goid, //optional
        "table": data.table, //optional,
        "procStatus": data.procStatus, // optional
        "fromDate": data.fromDate, // optional
        "toDate": data.toDate, // optional
    }


    let error = null;
    const request = await getAllGroupedOrders(body);
    let groupedOrderResponse = null;

    if (request.ok) {
        groupedOrderResponse = request.data
    } else {
        error = "Error getAllGroupedOrders";
    }
    return {
        data: {
            error: error,
            groupedOrder: groupedOrderResponse
        }
    };
}

export const createGroupedOrdersHandler = async (data) => {
    const body = {
        "shop": data.shop,
        "user": data.user,
        "place": data.place,
        "table": data.table,
        "procStatus": data.procStatus,
        "extGoid": data.extGoid, // optional
        "pickupTime": data.pickupTime, // optional
        "pickupDate": data.pickupDate, // optional
        "contact": data.contact, // optional
        "address": data.address, // optional
        "name": data.name // optional,

    }

    let error = null;
    const request = await createGroupedOrders(body);
    let groupedOrdersResponse = null;

    if (request.ok) {
        groupedOrdersResponse = request.data
    } else {
        error = request.data.internalCode;
    }
    return {
        data: {
            error: error,
            groupedOrder: groupedOrdersResponse
        }
    };
}

export const changeGroupedOrdersHandler = async (data) => {
    const body = {
        "shop": data.shop,
        "user": data.user,
        "goid": data.goid,
        "place": data.place,
        "procStatus": data.procStatus,
        "pickupTime": data.pickupTime, // optional
        "pickupDate": data.pickupDate, // optional
        "contact": data.contact, // optional
        "address": data.address, // optional
        "name": data.name // optional
    }

    let error = null;
    const request = await changeGroupedOrders(body);
    let groupedOrdersResponse = null;

    if (request.ok) {
        groupedOrdersResponse = request.data
    } else {
        error = "Error changeGroupedOrdersHandler";
    }
    return {
        data: {
            error: error,
            groupedOrder: groupedOrdersResponse
        }
    };
}


export const sendGroupedOrdersHandler = async (data) => {
    //returns the STATUS only
    const body = {
        "shop": data.shop,
        "user": data.user,
        "goid": data.goid,
    }
    let error = null;
    const request = await sendGroupedOrders(body);
    let statusResponse = null;

    if (request.ok) {
        statusResponse = request.data
    } else {
        error = "Error sendGroupedOrdersHandler";
    }
    return {
        data: {
            error: error,
            status: statusResponse
        }
    };
}

export const upsertGroupProductsOrderHandler = async (data) => {
    //returns the STATUS only
    const body = {
        "shop": data.shop,
        "user": data.user,
        "goid": data.goid,
        "oid":data.oid,
        "products": data.products,
        "name": data.name,
        "confirmed": data.confirmed
    }
    let error = null;
    const request = await upsertGroupProductsOrder(body);
    let upsertResponse = null;

    if (request.ok) {
        upsertResponse = request.data
    } else {
        error = "Error sendGroupedOrdersHandler";
    }
    return {
        data: {
            error: error,
            upsertResponse: upsertResponse
        }
    };
}


export const removeGroupProductsOrderHandler = async (data) => {
    //returns the STATUS only
    const body = {
        "shop": data.shop,
        "user": data.user,
        "goid": data.goid,
    }
    let error = null;
    const request = await removeGroupProductsOrder(body);
    let statusResponse = null;

    if (request.ok) {
        statusResponse = request.data
    } else {
        error = "Error removeGroupProductsOrderHandlers";
    }
    return {
        data: {
            error: error,
            status: statusResponse
        }
    };
}

export const deleteGroupedOrdersHandler = async (data) => {

    const body = {
        "shop": data.shop,
        "user": data.user,
        "goid": data.goid,
    }
    let error = null;
    const request = await deleteGroupedOrders(body);
    let statusResponse = null;

    if (request.ok) {
        statusResponse = request.data
    } else {
        error = "Error deleteGroupedOrdersHandler";
    }
    return {
        data: {
            error: error,
            status: statusResponse
        }
    };
}

export const confirmGroupProductsOrderHandler = async (data) => {

    const body = {
        "shop": data.shop,
        "user": data.user,
        "goid": data.goid,
    }
    let error = null;
    const request = await confirmGroupProductsOrder(body);
    let statusResponse = null;

    if (request.ok) {
        statusResponse = request.data
    } else {
        error = "Error deleteGroupedOrdersHandler";
    }
    return {
        data: {
            error: error,
            status: statusResponse
        }
    };
}
